export default "__VITE_ASSET__88cfea7d__"